export default "__VITE_ASSET__BuC8sTyA__"